"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightsOverview = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../utils/classFunctions");
const FlightOverviewColumn_1 = require("./FlightOverviewColumn");
require("./index.scss");
const FlightsOverview = (props) => {
    const { flightColumns, minDesktopCard, isPageBlock = true, } = props;
    const classNames = (0, classFunctions_1.getClassNames)('flight-overview', [
        flightColumns.length > 3 ? 'min' : undefined,
        isPageBlock ? 'is-page-block' : undefined,
    ]);
    const style = { '--columns': flightColumns.length };
    return (react_1.default.createElement("div", { className: classNames, style: style }, flightColumns.map(column => (react_1.default.createElement(FlightOverviewColumn_1.FlightOverviewColumn, { className: 'flight-overview__column', key: column.title, data: column, minDesktopCard: !!minDesktopCard })))));
};
exports.FlightsOverview = FlightsOverview;
//# sourceMappingURL=index.js.map